import { formatDate, parseDate } from '@/util'

export const parseAndFormatDate = (date: string): string => {
  const formattedDate = formatDate(parseDate(date), 'M-d-yyyy, h:mm a') ?? '---'
  if (!date) return '---'
  else return formattedDate
}
